<div class="text-center">
  <a class="btn btn-primary" routerLink="/admin/actions/admin/create">Add Admin</a>
</div>
<div>
  <app-base-report [hasCheckboxes]="false" [reportName]="'Admin Mangement'" [defaultColumns]="displayedColumns"
                   [columnsDisplayNames]="displayTableColumns" [data]="adminManagementReportData" [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)" (paginationChange)="paginate($event)" (searchChange)="searchChange($event)"
                   [tableLoading]="loading" [hasSort]="true" (sortTrigger)="sortChange($event)" [rowActions]="rowActions"
                   (rowActionClicked)="onRowAction($event)" [serviceInstance]="getAdminsMangementService"></app-base-report>
</div>
